// @ts-nocheck
/*
 * Armador de "Arma tu pack" (v2, 2026-10-02).
 *
 * El cliente suma cajas de 5 y de 20 de los sabores que quiera. El precio se
 * calcula desde las cajas REALES que van al carro, no desde un producto
 * cascaron: por eso no puede desfasarse de lo que cobra el checkout, que es el
 * error que costo $2.000 por pedido en el Pack 20 en agosto de 2026.
 *
 * Los descuentos que simula son los mismos que Shopify aplica solo:
 *   - familia Caja 5: por cantidad de cajas (2, 3 o 4+), solo productos caja 5
 *   - escalera: por cantidad de cajas de 20 (barritas del tramo / 20), solo
 *     productos caja 20. Las cajas de 5 NO cuentan para la escalera.
 * Shopify aplica UN solo descuento de clase producto, el mayor que califique.
 * (_totales y _agregar vienen sin cambios de la version del 2026-09-22.)
 *
 * Lo que pinta: filas con pestañas (celular), tarjetas (PC), tarjetas de tramo
 * (celular), el resumen, el panel de avance (PC a la derecha y celular en la
 * hoja) con un casillero por caja de 20 en el orden en que se agregaron, y la
 * barra negra de celular. Todo sale de un solo estado y un solo calculo.
 *
 * El regalo del Cyber se pregunta a window.EpCyber (assets/ep-cyber.js). En un
 * tema sin ese archivo no se menciona nunca.
 */
class EpArmaPack extends HTMLElement {
  connectedCallback() {
    this._cfg = this._leerConfig();
    if (!this._cfg) return;
    this._estado = {};
    this._orden = [];     // cajas en el orden en que se agregaron, para los casilleros
    this._nuevo = -1;     // la ultima agregada, para la animacion
    this._cfg.sabores.forEach((s, i) => { this._estado[i] = { c20: 0, c5: 0 }; });
    this._pintarListas();
    this._pintarTramosBase();
    this._verTab('c20');
    this._bind();
    this._calcular();
    this._vigilarResumen();
    document.addEventListener('epcyber:cambio', () => { this._pintarTramosBase(); this._calcular(); });
    /* Al volver con "atras" desde /cart el navegador trae la pagina congelada con el pack
       armado, que ya esta en el carro: si el cliente vuelve a agregar, las cajas se suman a
       las que ya estan. Por eso el armador parte en cero (revision del 2026-10-02). */
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      Object.values(this._estado).forEach((x) => { x.c20 = 0; x.c5 = 0; });
      this._orden = []; this._cargando = false; this._hoja(false);
      this._calcular();
    });
  }

  _leerConfig() {
    const el = document.getElementById(`ep-arma-pack-config-${this.dataset.sectionId}`);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  _q(s) { return this.querySelector(s); }
  _todos(s, fn) { this.querySelectorAll(s).forEach(fn); }
  _plata(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  _regalo() {
    try { return !!(window.EpCyber && window.EpCyber.estado().regalo); } catch (e) { return false; }
  }
  _esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  // ---------------------------------------------------------------- pintado fijo
  _controles(i, fmt, nombre) {
    return `<div class="ep-ap__ctl">
      <button type="button" class="ep-ap__add" data-ap-add data-i="${i}" data-fmt="${fmt}">${this._esc(this._cfg.textos.agregar)}</button>
      <div class="ep-ap__step" data-i="${i}" data-fmt="${fmt}">
        <button type="button" data-ap-menos aria-label="Quitar una caja de ${this._esc(nombre)}">&minus;</button>
        <b data-ap-val aria-live="polite">0</b>
        <button type="button" data-ap-mas aria-label="Agregar una caja de ${this._esc(nombre)}">+</button>
      </div></div>`;
  }

  _meta(fmt) {
    const c = this._cfg;
    return fmt === 'c20' ? `${c.barrasPorCaja20} barritas · ${this._plata(c.precio20)}` : `${c.barrasPorCaja5} barritas · ${this._plata(c.precio5)}`;
  }

  _pintarListas() {
    const c = this._cfg;
    ['c20', 'c5'].forEach((fmt) => {
      const filas = this._q(`[data-ap-lista="${fmt}"]`);
      const cards = this._q(`[data-ap-cards="${fmt}"]`);
      let hf = '', hc = '';
      c.sabores.forEach((s, i) => {
        if (!s[fmt].id) return;   // sabor sin variante cargada para ese formato
        const img = s[fmt].img ? `<img src="${s[fmt].img}" alt="${this._esc(s.nombre)}" loading="lazy" width="400" height="400">` : '';
        hf += `<div class="ep-ap__fila" data-ap-par="${i}-${fmt}"><div class="ep-ap__fila-img">${img}</div>
          <div class="ep-ap__fila-txt"><div class="ep-ap__nom">${this._esc(s.nombre)}</div><div class="ep-ap__meta">${this._meta(fmt)}</div></div>
          ${this._controles(i, fmt, s.nombre)}</div>`;
        hc += `<div class="ep-ap__cd" data-ap-par="${i}-${fmt}"><div class="ep-ap__cd-img">${img}</div>
          <div class="ep-ap__nom">${this._esc(s.nombre)}</div><div class="ep-ap__meta">${this._meta(fmt)}</div>
          ${this._controles(i, fmt, s.nombre)}</div>`;
      });
      if (filas) filas.innerHTML = hf;
      if (cards) cards.innerHTML = hc;
    });
    // encabezados de PC: precio de la caja y precio por barrita, calculados
    const sub = (fmt, precio, barras, nota) => {
      const t = this._q(`[data-ap-subtit="${fmt}"]`), n = this._q(`[data-ap-subnota="${fmt}"]`);
      if (t) t.textContent = `${fmt === 'c20' ? this._q('[data-ap-tab="c20"]').firstChild.textContent.trim() : this._q('[data-ap-tab="c5"]').firstChild.textContent.trim()} · ${this._plata(precio)}`;
      if (n) n.textContent = `${this._plata(precio / barras)} por barrita${nota ? ' · ' + nota : ''}`;
    };
    sub('c20', c.precio20, c.barrasPorCaja20, '');
    sub('c5', c.precio5, c.barrasPorCaja5, c.textos.notaC5);
  }

  _cajasTramo(t) { return Math.ceil(t.barras / this._cfg.barrasPorCaja20); }

  _pintarTramosBase() {
    const cont = this._q('[data-ap-tramos]');
    if (!cont) return;
    const c = this._cfg, reg = this._regalo();
    const camion = '<svg class="ep-ap__camion" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11v14H5z"/><path d="M14 17h1a2 2 0 0 0 2-2v-3l-3.5-4H14V3"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    cont.innerHTML = [...c.escalera].sort((a, b) => a.barras - b.barras).map((t) => {
      const cajas = this._cajasTramo(t);
      return `<div class="ep-ap__tr" data-ap-tramo="${cajas}">
        <span class="ep-ap__radio"></span>
        <div class="ep-ap__tr-txt"><div class="ep-ap__tr-qty">${t.barras} barritas</div>
          <div class="ep-ap__tr-unit">${cajas} cajas · ${this._plata(t.precio / t.barras)} por barrita</div>
          ${t.pct ? `<span class="ep-ap__off">${this._esc(t.pct)} OFF</span>` : ''}</div>
        <div class="ep-ap__tr-der"><span class="ep-ap__tr-precio">${this._plata(t.precio)}</span>
          <span class="ep-ap__tr-tach">${this._plata(cajas * c.precio20)}</span>
          ${c.envioGratisDesde && t.precio >= c.envioGratisDesde ? `<span class="ep-ap__tr-env">${camion}${this._esc(c.textos.envioCorto)}</span>` : ''}
          ${reg && cajas >= 2 && c.textos.regaloTramo ? `<span class="ep-ap__tr-reg">${this._esc(c.textos.regaloTramo)}</span>` : ''}
        </div></div>`;
    }).join('');
  }

  // ---------------------------------------------------------------- eventos
  _bind() {
    this.addEventListener('click', (e) => {
      const g = (s) => e.target.closest(s);
      let b;
      if ((b = g('[data-ap-tab]'))) { this._verTab(b.dataset.apTab); return; }
      if ((b = g('[data-ap-add]'))) { this._sumar(+b.dataset.i, b.dataset.fmt); return; }
      if ((b = g('[data-ap-mas]'))) { const st = b.closest('[data-i]'); this._sumar(+st.dataset.i, st.dataset.fmt); return; }
      if ((b = g('[data-ap-menos]'))) { const st = b.closest('[data-i]'); this._restar(+st.dataset.i, st.dataset.fmt); return; }
      if ((b = g('[data-ap-quitar]'))) { this._quitar(+b.dataset.apQuitar); return; }
      if (g('[data-ap-mix]')) {
        this._cfg.sabores.forEach((s, i) => { if (s.c20.id) { this._estado[i].c20++; this._orden.push({ i, fmt: 'c20' }); } });
        this._nuevo = this._orden.length - 1; this._calcular(); return;
      }
      if (g('[data-ap-abrir]')) { this._hoja(true); return; }
      if (g('[data-ap-cerrar]')) { this._hoja(false); return; }
      if ((b = g('[data-ap-cta],[data-ap-b-cta]')) && !b.disabled) { this._agregar(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this._hoja(false); });
  }

  _sumar(i, fmt) {
    this._estado[i][fmt]++;
    this._orden.push({ i, fmt }); this._nuevo = this._orden.length - 1;
    this._calcular();
  }
  _restar(i, fmt) {
    if (!this._estado[i][fmt]) return;
    this._estado[i][fmt]--;
    for (let k = this._orden.length - 1; k >= 0; k--) {
      if (this._orden[k].i === i && this._orden[k].fmt === fmt) { this._orden.splice(k, 1); break; }
    }
    this._calcular();
  }
  _quitar(idx) {
    const o = this._orden.splice(idx, 1)[0];
    if (o && this._estado[o.i][o.fmt] > 0) this._estado[o.i][o.fmt]--;
    this._calcular();
  }

  _verTab(fmt) {
    this._todos('[data-ap-tab]', (b) => { const on = b.dataset.apTab === fmt; b.classList.toggle('ep-ap__tab--on', on); b.setAttribute('aria-selected', on); });
    this._todos('[data-ap-lista]', (l) => { l.hidden = l.dataset.apLista !== fmt; });
    const sub = this._q('[data-ap-tabsub]');
    const c = this._cfg;
    if (sub) {
      sub.textContent = fmt === 'c20'
        ? `${this._meta('c20')} · ${this._plata(c.precio20 / c.barrasPorCaja20)} por barrita`
        : `${this._meta('c5')}${c.textos.notaC5 ? ' · ' + c.textos.notaC5 : ''}`;
    }
  }

  _hoja(abrir) {
    this.classList.toggle('ep-ap--hoja', abrir);
    document.documentElement.classList.toggle('ep-ap-sin-scroll', abrir);
  }

  /* Barra fija de celular: se esconde mientras el resumen esta a la vista,
     para no mostrar el total dos veces. En escritorio la oculta el CSS. */
  _vigilarResumen() {
    const barra = this._q('[data-ap-barra]'), res = this._q('[data-ap-res]');
    if (!barra || !res || !('IntersectionObserver' in window)) return;
    new IntersectionObserver((es) => es.forEach((x) => {
      barra.classList.toggle('ep-ap__barra--off', x.isIntersecting && x.intersectionRatio > 0.4);
    }), { threshold: [0, 0.4, 0.8] }).observe(res);
  }

  // ---------------------------------------------------------------- calculo
  _descFamilia5(n5) {
    let d = 0;
    (this._cfg.familia5 || []).forEach((t) => { if (n5 >= t.min) d = Math.max(d, t.desc); });
    return d;
  }

  _tramoDe(n20) {
    let elegido = null;
    (this._cfg.escalera || []).forEach((t) => {
      if (n20 >= this._cajasTramo(t) && (!elegido || t.barras > elegido.barras)) elegido = t;
    });
    return elegido;
  }

  _totales() {
    let n20 = 0, n5 = 0;
    Object.values(this._estado).forEach((e) => { n20 += e.c20; n5 += e.c5; });
    const barras = n20 * this._cfg.barrasPorCaja20 + n5 * this._cfg.barrasPorCaja5;
    const lista = n20 * this._cfg.precio20 + n5 * this._cfg.precio5;
    const tramo = this._tramoDe(n20);
    const desc = Math.max(tramo ? tramo.desc : 0, this._descFamilia5(n5));
    return { n20, n5, barras, lista, desc, paga: lista - desc, tramo };
  }

  _textoEnvio(t) {
    const c = this._cfg, umbral = c.envioGratisDesde;
    if (!umbral) return { html: '', si: false };
    if (!t.barras) return { html: c.textos.envioVacio, si: false };
    if (t.paga >= umbral) return { html: c.textos.envioSi, si: true };
    return { html: c.textos.envioFalta.replace('{monto}', `<b>${this._plata(umbral - t.paga)}</b>`), si: false };
  }

  /* Todo se calcula sobre el carro que quedaria al sumar esas cajas, con la
     misma regla que Shopify, nunca supuesto: el ahorro extra es la diferencia
     real contra el descuento que ya tiene (que puede venir de las cajas de 5), y
     el envio gratis se menciona solo si ese carro de verdad pasa el umbral. */
  _textoProgreso(t) {
    const c = this._cfg, reg = this._regalo();
    const orden = [...c.escalera].sort((a, b) => a.barras - b.barras);
    const sig = orden.find((x) => t.n20 < this._cajasTramo(x));
    let html, max = false;
    if (!t.barras) {
      html = '';
    } else if (!sig) {
      html = c.textos.progMax; max = true;
    } else {
      const faltan = this._cajasTramo(sig) - t.n20;
      const descNuevo = Math.max(sig.desc, this._descFamilia5(t.n5));
      const extra = descNuevo - t.desc;
      const pagaNueva = t.lista + faltan * c.precio20 - descNuevo;
      const umbral = c.envioGratisDesde;
      const ganaEnvio = umbral && t.paga < umbral && pagaNueva >= umbral && c.textos.progFaltaEnvio;
      const cajas = `<b>${faltan} ${faltan === 1 ? 'caja' : 'cajas'} de ${c.barrasPorCaja20}</b>`;
      html = (ganaEnvio ? c.textos.progFaltaEnvio : c.textos.progFalta)
        .replace('{cajas}', cajas).replace('{extra}', `<b>${this._plata(extra)}</b>`);
      // el regalo del Cyber se gana desde 2 cajas de 20 (assets/ep-regalo-cyber.js)
      if (reg && t.n20 < 2 && t.n20 + faltan >= 2 && c.textos.regaloSuma) html = html.replace(/\.\s*$/, '') + ' ' + c.textos.regaloSuma + '.';
    }
    if (reg && t.n20 >= 2 && c.textos.regaloLleva) html = c.textos.regaloLleva + ' ' + html;
    return { html, max };
  }

  _etiqueta(k) {
    if (k === 1) return String(this._cfg.barrasPorCaja20);
    const t = this._cfg.escalera.find((x) => this._cajasTramo(x) === k);
    return t ? `${t.barras}${t.pct ? ' · ' + t.pct : ''}` : '';
  }

  _slotsHtml(t) {
    const c = this._cfg;
    const c20 = this._orden.map((o, idx) => ({ ...o, idx })).filter((o) => o.fmt === 'c20');
    const tope = Math.max(0, ...c.escalera.map((x) => this._cajasTramo(x)));
    let h = '';
    for (let k = 1; k <= Math.max(tope, c20.length); k++) {
      const o = c20[k - 1], lab = this._etiqueta(k);
      const s = o && c.sabores[o.i];
      const box = o
        ? `<div class="ep-ap__sl-box ep-ap__sl-box--on${o.idx === this._nuevo ? ' ep-ap__nuevo' : ''}" style="background:${s.color};color:${s.texto}">
             <span>${this._esc(s.nombre)}</span><button type="button" data-ap-quitar="${o.idx}" aria-label="Quitar una caja de ${this._esc(s.nombre)}">×</button></div>`
        : '<div class="ep-ap__sl-box"></div>';
      h += `<div>${box}<div class="ep-ap__sl-lab${lab && t.n20 >= k ? ' on' : ''}">${lab}</div></div>`;
    }
    return h;
  }

  _slots5Html() {
    const c = this._cfg;
    const c5 = this._orden.map((o, idx) => ({ ...o, idx })).filter((o) => o.fmt === 'c5');
    if (!c5.length) return '';
    return `<div class="ep-ap__c5-tit">${this._esc(this._q('[data-ap-tab="c5"]').firstChild.textContent.trim())}</div><div class="ep-ap__c5-fila">${c5.map((o) => {
      const s = c.sabores[o.i];
      return `<div class="ep-ap__c5-box${o.idx === this._nuevo ? ' ep-ap__nuevo' : ''}" style="background:${s.color};color:${s.texto}" title="${this._esc(s.nombre)}">${c.barrasPorCaja5}<button type="button" data-ap-quitar="${o.idx}" aria-label="Quitar una caja de ${this._esc(s.nombre)}">×</button></div>`;
    }).join('')}</div>`;
  }

  // Barra de celular: solo las cajas que hay mas un casillero para la proxima,
  // sin un total que haga sentir que hay que llegar a 6 (Tomi, 2026-10-02).
  _miniHtml() {
    const c20 = this._orden.filter((o) => o.fmt === 'c20');
    let h = '';
    for (let k = 0; k <= c20.length; k++) {
      const o = c20[k], s = o && this._cfg.sabores[o.i];
      h += s ? `<i style="background:${s.color};border-color:${s.color}"></i>` : '<i></i>';
    }
    return h;
  }

  _calcular() {
    const t = this._totales();
    const c = this._cfg, T = c.textos, plata = (n) => this._plata(n);
    const env = this._textoEnvio(t), prog = this._textoProgreso(t);

    // filas y tarjetas: "Agregar" hasta la primera caja, despues el contador
    this._todos('[data-ap-par]', (el) => {
      const [i, fmt] = el.dataset.apPar.split('-');
      const n = this._estado[+i][fmt];
      el.classList.toggle('tiene', n > 0);
      el.querySelector('[data-ap-val]').textContent = n;
    });
    [['c20', t.n20], ['c5', t.n5]].forEach(([f, n]) => this._todos(`[data-ap-n="${f}"]`, (i) => { i.hidden = !n; i.textContent = n; }));

    // tramos de celular: el que tienes queda marcado
    this._todos('[data-ap-tramo]', (el) => {
      const on = !!t.tramo && this._cajasTramo(t.tramo) === +el.dataset.apTramo;
      el.classList.toggle('ep-ap__tr--on', on);
      let f = el.querySelector('.ep-ap__flag');
      if (on && !f) { f = document.createElement('span'); f.className = 'ep-ap__flag'; f.textContent = T.tuPack; el.appendChild(f); }
      if (!on && f) f.remove();
    });

    // resumen y paneles (hay uno en PC y otro en la hoja de celular)
    const cuenta = [t.n20 ? `${t.n20} ${t.n20 === 1 ? 'caja' : 'cajas'} de ${c.barrasPorCaja20}` : '', t.n5 ? `${t.n5} de ${c.barrasPorCaja5}` : ''].filter(Boolean).join(' · ');
    const tope = Math.max(1, ...c.escalera.map((x) => this._cajasTramo(x)));
    const pct = t.tramo && t.desc === t.tramo.desc && t.tramo.pct ? `${t.tramo.pct} OFF` : '';
    this._todos('[data-ap-barras]', (el) => { el.textContent = t.barras; });
    this._todos('[data-ap-cuenta]', (el) => { el.textContent = t.barras ? `${cuenta} · ${t.barras} barritas` : T.tuPack; });
    this._todos('[data-ap-pct]', (el) => { el.textContent = pct; });
    this._todos('[data-ap-bar]', (el) => { el.style.width = `${Math.min(100, t.n20 / tope * 100)}%`; });
    this._todos('[data-ap-slots]', (el) => { el.innerHTML = this._slotsHtml(t); });
    this._todos('[data-ap-slots5]', (el) => { el.innerHTML = this._slots5Html(); });
    this._todos('[data-ap-tot]', (el) => { el.textContent = plata(t.paga); });
    this._todos('[data-ap-tach]', (el) => { el.textContent = t.desc ? plata(t.lista) : ''; });
    this._todos('[data-ap-unit]', (el) => { el.textContent = t.barras ? `${plata(t.paga / t.barras)} c/u` : ''; });
    this._todos('[data-ap-aho]', (el) => { el.textContent = t.desc ? `${T.barraAhorro} ${plata(t.desc)}` : ''; });
    this._todos('[data-ap-env]', (el) => { el.innerHTML = env.html; el.classList.toggle('ep-ap__env--si', env.si); });
    this._todos('[data-ap-prog]', (el) => { el.innerHTML = prog.html; el.classList.toggle('ep-ap__prog--max', prog.max); });
    if (!this._cargando) {
      this._todos('[data-ap-cta]', (el) => { el.disabled = !t.barras; el.textContent = t.barras ? T.cta : T.ctaVacio; });
    }

    // barra negra de celular
    const b = this._q('[data-ap-barra]');
    if (b) {
      const aho = b.querySelector('[data-ap-b-aho]');
      aho.hidden = !t.desc; aho.textContent = `${T.barraAhorro} ${plata(t.desc)}`;
      // sticker rojo cuando el carro llega al envio gratis (Tomi, 2026-10-02)
      b.querySelector('[data-ap-b-envf]').hidden = !env.si;
      b.querySelector('[data-ap-mini]').innerHTML = this._miniHtml();
      b.querySelector('[data-ap-b-cuenta]').textContent = t.barras ? cuenta : T.barraVacio;
      b.querySelector('[data-ap-b-tot]').textContent = plata(t.paga);
      b.querySelector('[data-ap-b-qty]').textContent = t.barras ? `${t.barras} barritas` : '';
      const be = b.querySelector('[data-ap-b-env]');
      be.innerHTML = env.html; be.classList.toggle('ep-ap__b-env--si', env.si);
      if (!this._cargando) b.querySelector('[data-ap-b-cta]').disabled = !t.barras;
    }
    this._nuevo = -1;
  }

  // ---------------------------------------------------------------- carrito
  async _agregar() {
    const items = [];
    this._cfg.sabores.forEach((s, i) => {
      ['c20', 'c5'].forEach((fmt) => {
        const n = this._estado[i][fmt];
        if (n > 0 && s[fmt].id) items.push({ id: parseInt(s[fmt].id, 10), quantity: n });
      });
    });
    if (!items.length || this._cargando) return;

    const ctas = this.querySelectorAll('[data-ap-cta],[data-ap-b-cta]');
    this._cargando = true;
    ctas.forEach((b) => { b.disabled = true; if (b.hasAttribute('data-ap-cta')) b.textContent = this._cfg.textos.ctaCargando; });
    this._todos('[data-ap-error]', (e) => { e.hidden = true; });

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!r.ok) throw new Error('cart');
      // _cargando sigue en true hasta salir: mientras carga /cart no se puede mandar otro pedido
      window.location.href = '/cart';
    } catch (e) {
      this._cargando = false;
      this._calcular();
      this._todos('[data-ap-error]', (el) => { el.textContent = this._cfg.textos.error; el.hidden = false; });
    }
  }
}

if (!customElements.get('ep-arma-pack')) {
  customElements.define('ep-arma-pack', EpArmaPack);
}
